module.exports = require('scryptsy')



//////////////////
// WEBPACK FOOTER
// ./~/scrypt.js/js.js
// module id = 567
// module chunks = 0